import { Button, CircularProgress, Tooltip } from "@mui/material";
import { useState, useRef } from "react";
import Translate from "../utils/Translate";
import ConditionalWrapper from "./ConditionalWrapper";

export default function ButtonWithSpinner({ onClick, children, tooltip, variant, disabled, ...rest }) {
  const [buttonWidth, setButtonWidth] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const buttonRef = useRef(null);
  const isLoadingRef = useRef(false); // Need ref in addition to state to avoid double clicks before state update

  async function handleClick() {
    if (isLoadingRef.current) return;

    setButtonWidth(buttonRef.current.offsetWidth);
    isLoadingRef.current = true;
    setIsLoading(true);

    try {
      await onClick();
    } finally {
      setButtonWidth(null);
      isLoadingRef.current = false;
      setIsLoading(false);
    }
  }

  return (
    <ConditionalWrapper condition={tooltip} wrapper={(children) => <Tooltip title={tooltip}>{children}</Tooltip>}>
      <Button
        {...rest}
        variant={variant}
        disabled={disabled}
        startIcon={isLoading ? null : rest.startIcon}
        endIcon={isLoading ? null : rest.endIcon}
        onClick={handleClick}
        ref={buttonRef}
        sx={buttonWidth ? { width: `${buttonWidth}px`, ...rest?.sx } : { ...rest?.sx }}
      >
        {isLoading ? <CircularProgress color="inherit" size={23} /> : children}
      </Button>
    </ConditionalWrapper>
  );
}
